<div class="close-popup">
  <div class="mt-5 flex flex-row justify-content-center">
    {{ 'SESSION_EXPIRED_MESSAGE' | translate }}
  </div>

  <div class="mt-5 btn-group flex-row justify-content-center">
    <app-base-button ngClass="mr-2" label="LOGIN" (click)="logout()">
    </app-base-button>
  </div>
</div>
